import { render, staticRenderFns } from "./deviceRepair.vue?vue&type=template&id=c5356922&scoped=true&"
import script from "./deviceRepair.vue?vue&type=script&lang=js&"
export * from "./deviceRepair.vue?vue&type=script&lang=js&"
import style0 from "./deviceRepair.vue?vue&type=style&index=0&id=c5356922&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5356922",
  null
  
)

export default component.exports